var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignInBadgeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09248 21.6486L7.48116 21.7002L7.1158 24.4508C7.11556 24.4526 7.11579 24.4544 7.11646 24.4561C7.11713 24.4578 7.11822 24.4593 7.11963 24.4604L6.87226 24.7647L7.11964 24.4605C7.12106 24.4616 7.12274 24.4624 7.12452 24.4627C7.12631 24.463 7.12815 24.4628 7.12986 24.4622L7.12989 24.4622L9.69276 23.5634C10.0222 23.4478 10.3812 23.4478 10.7107 23.5634L13.2735 24.4622L13.2735 24.4622C13.2753 24.4628 13.2771 24.463 13.2789 24.4627C13.2807 24.4624 13.2824 24.4616 13.2838 24.4605L13.5311 24.7647L13.2838 24.4604C13.2852 24.4593 13.2863 24.4578 13.287 24.4561C13.2876 24.4544 13.2878 24.4526 13.2876 24.4508C13.2876 24.4508 13.2876 24.4508 13.2876 24.4508L12.9223 21.7002C12.9128 21.6293 12.8806 21.5879 12.8457 21.5645C12.8092 21.5399 12.7507 21.5227 12.6719 21.5399C11.8613 21.7167 11.0335 21.8071 10.2026 21.8092L10.2008 21.8092C9.36976 21.8073 8.54206 21.7167 7.7315 21.5399M7.09248 21.6486L7.7315 21.5399M7.09248 21.6486L7.48116 21.7002C7.49535 21.5933 7.56566 21.5351 7.6647 21.533C7.66472 21.533 7.66475 21.533 7.66477 21.533L7.09248 21.6486ZM7.7315 21.5399C7.71122 21.5355 7.6927 21.5334 7.67593 21.533M7.7315 21.5399C7.73154 21.5399 7.73158 21.5399 7.73162 21.5399L7.67593 21.533M7.67593 21.533C7.67592 21.533 7.67591 21.533 7.6759 21.533L7.67593 21.533ZM3.80369 3.69072C5.50053 1.99386 7.80195 1.04056 10.2017 1.04053C12.6014 1.04054 14.9028 1.99382 16.5997 3.69069C18.2965 5.38755 19.2498 7.68899 19.2498 10.0887C19.2499 11.277 19.0158 12.4536 18.5611 13.5513C18.1064 14.6491 17.4399 15.6466 16.5997 16.4868C15.7595 17.327 14.762 17.9935 13.6643 18.4483C12.5665 18.903 11.3899 19.137 10.2017 19.137C7.80193 19.137 5.5005 18.1837 3.80365 16.4868C2.10681 14.7899 1.15355 12.4884 1.15357 10.0887C1.15357 7.68901 2.10685 5.38759 3.80369 3.69072Z",
    fill: "#D7DFFF",
    stroke: "#5D5FEF",
    strokeWidth: 0.784193
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20809_26425)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20809_26425",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05322 6.03727H15.3519V16.3359H5.05322V6.03727Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20809_26425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2027 6.43561L6.26025 8.07247V10.0623C6.26025 12.6375 7.81851 14.9565 10.2027 15.9297C12.5869 14.9565 14.1452 12.6375 14.1452 10.0623V8.07247L10.2027 6.43561Z",
    fill: "white",
    stroke: "#5D5FEF",
    strokeWidth: 0.804583,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63354 10.8679L9.75783 11.9922L11.7714 9.97862",
    stroke: "#5D5FEF",
    strokeWidth: 0.804583,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20809_26425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.2987,
    height: 10.2987,
    fill: "white",
    transform: "translate(5.05225 6.03125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInBadgeIcon);
export default __webpack_public_path__ + "static/media/SignInBadgeIcon.75f7f947e3b2318b4408de61627bcc76.svg";
export { ForwardRef as ReactComponent };